export default "__VITE_ASSET__C_r_aNs9__"